// AUTO-GENERATED by tools/finalize-w15.mjs (manual finalizer; cfg3 timed out).
// Pool: cfg0+cfg1+cfg2 = 140 candidates. Selected 10.
// W15 (Cairn) — first non-clear objective. Target tiles must land on
// // specific cells. d=2-7 band; targetCount 1-3 per board.
import type { LevelDef } from '@tessera/engine';

export const WORLD_15_GENERATED: LevelDef[] = [
  // d*=2  branching=25.50  D=0.145  tiles=10
  {
    id: 'w15-l01',
    world: 15,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 4, targets: [{ coord: { q: 1, r: 0 }, color: 1 }] },
    tiles: [
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 2 },
    ],
  },
  // d*=2  branching=22.49  D=0.164  tiles=10
  {
    id: 'w15-l02',
    world: 15,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 4, targets: [{ coord: { q: 1, r: -2 }, color: 0 }] },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2 },
    ],
  },
  // d*=3  branching=21.94  D=0.278  tiles=10
  {
    id: 'w15-l03',
    world: 15,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 5, targets: [{ coord: { q: 0, r: 2 }, color: 0 }] },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=3  branching=24.63  D=0.289  tiles=10
  {
    id: 'w15-l04',
    world: 15,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 5, targets: [{ coord: { q: 1, r: 0 }, color: 0 }] },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=4  branching=23.75  D=0.314  tiles=10
  {
    id: 'w15-l05',
    world: 15,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 6, targets: [{ coord: { q: 1, r: 0 }, color: 0 }] },
    tiles: [
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    ],
  },
  // d*=4  branching=19.92  D=0.359  tiles=10
  {
    id: 'w15-l06',
    world: 15,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 6, targets: [{ coord: { q: 2, r: 0 }, color: 1 }] },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    ],
  },
  // d*=5  branching=27.09  D=0.310  tiles=10
  {
    id: 'w15-l07',
    world: 15,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 7, targets: [{ coord: { q: 0, r: 0 }, color: 0 }] },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    ],
  },
  // d*=5  branching=19.97  D=0.313  tiles=10
  {
    id: 'w15-l08',
    world: 15,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 7, targets: [{ coord: { q: 1, r: 0 }, color: 2 }] },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=23.63  D=0.360  tiles=11
  {
    id: 'w15-l09',
    world: 15,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'target', moveBudget: 8, targets: [{ coord: { q: 2, r: -1 }, color: 2 }, { coord: { q: -1, r: 0 }, color: 0 }] },
    tiles: [
    { coord: { q: 2, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=7  branching=29.58  D=0.506  tiles=12
  {
    id: 'w15-l10',
    world: 15,
    index: 10,
    radius: 4,
    holes: [],
    objective: { kind: 'target', moveBudget: 9, targets: [{ coord: { q: 0, r: 4 }, color: 2 }, { coord: { q: 1, r: -1 }, color: 0 }] },
    tiles: [
    { coord: { q: -2, r: 4 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -4 }, color: 0 },
    { coord: { q: 4, r: -4 }, color: 0 },
    { coord: { q: 1, r: 3 }, color: 1 },
    { coord: { q: 2, r: 2 }, color: 1 },
    { coord: { q: -2, r: -2 }, color: 2 },
    { coord: { q: -4, r: 0 }, color: 2 },
    { coord: { q: 4, r: -3 }, color: 3 },
    { coord: { q: 4, r: -1 }, color: 3 },
    ],
  },
];
